module.exports = {
  Visor3D: {
    Auto_rotate: "Rotate",
    Allow_fullscreen: "Allow fullscreen",
    background_color: "Background color",
    border_color: "Border color",
    border_size: "Border Size",
    border_style: "Border Style",
    box_style: "Box style",
    color: "Color",
    opacity: "Opacity",
    padding: "Padding",
    PluginName: "Visor 3D",
    radius: "Radius",
    // "Scroll": "Scroll",
    settings: "Settings",
    source: "Source",
    style: "Plugin style",
    URL: "URL",
  },
};
